import { IPagingSettings, ISiteModel, ISortingSettings } from '@module/shared/components/Site/models';
import { SiteApiClient } from '../services/siteApiClient';
import { handleErrors, SITE_API_URI } from './constants';

const client = new SiteApiClient(SITE_API_URI);
const basePath = `${environmentSettings.apiUrl}Sites`;

export async function requestSiteGet(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string): Promise<any[]> {
    const response = fromServIs ?
        await getAllServIsSites(pagingSettings.pageSize, pagingSettings.skipItems, sortingSettings.sortField, sortingSettings.sortDirection, searchFilter, accessToken) :
        await getAllSites(pagingSettings.pageSize, pagingSettings.skipItems, sortingSettings.sortField, sortingSettings.sortDirection, searchFilter, accessToken);
    if (response.ok) {
        const json = await response.json();
        return mapToSite(json);
    } else {
        return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
}

async function getAllServIsSites(pageSize: number, skip: number, orderBy: string, sortOrder: string, searchFilter: string, accessToken: string) {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + accessToken);
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
    return fetch(`${basePath}/ServIs?pageSize=${pageSize}&skip=${skip}&orderBy=${orderBy}&sortOrder=${sortOrder}&searchData=${searchFilter}`, { headers, method: 'GET', cache: 'no-store' });
}

async function getAllSites(pageSize: number, skip: number, orderBy: string, sortOrder: string, searchFilter: string, accessToken: string) {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + accessToken);
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
    return fetch(`${basePath}?pageSize=${pageSize}&skip=${skip}&orderBy=${orderBy}&sortOrder=${sortOrder}&searchData=${searchFilter}`, { headers, method: 'GET', cache: 'no-store' });
}

function mapToSite(data: any) {
    return data.sites.map((site: any) => {
        return {
            name: site.siteName,
            siteId: site.id,
            customer: site.owner,
            region: site.regionName,
            servIsId: site.servIsId,
            registered: site.registered
        };
    });
}

export function requestSiteGetById(servIsId: string, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.getServIsSite(servIsId, accessToken).then((site: any) => {
                const siteResponse: any = {
                    siteName: site.siteName,
                    owner: site.owner,
                    regionName: site.regionName,
                    servIsId: site.servIsId,
                    operator: site.operator,
                    country: site.country,
                    city: site.city
                };
                resolve(siteResponse);
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestSitePost(site: ISiteModel, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.registerSite(site, accessToken).then(handleErrors).then((data: any) => {
                const siteResponse: ISiteModel = {
                    name: data.siteName,
                    siteId: data.id,
                    customer: data.owner,
                    region: data.regionName,
                    servIsId: data.servIsId,
                    registered: site.registered
                };
                resolve(siteResponse);
            }).catch((data: any) => {
                reject(data);
            });
        }
    );
}

export function requestSitePut(siteId: number, servIsId: string, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.updateSite(siteId, servIsId, accessToken)
            .then(data => resolve(data))
            .catch((err: any) => {
                reject(err);
            });
        }
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/services/siteDataService.ts